var lib_core      = require("lib-core");
var lib_geometry  = require("lib-geometry");


var LocalYRotationModel = require("./localYRotationModel.js");
var LocalYRotationView = require("./localYRotationView.js");

var Editor3d = require("./../../editor3d/editor3dController.js");

var LocalYRotationController = function(archLayers, dependencies, options) {
    lib_core.Controller.call(this, archLayers, dependencies, options);
};

lib_core.inherit(LocalYRotationController, lib_core.Controller);
LocalYRotationController.inject = {
    editor3d : Editor3d
};

module.exports = LocalYRotationController;

LocalYRotationController.prototype.handleId = "rotationLocalY";

LocalYRotationController.prototype.createModel = function () {
    var editor3dModel = this.editor3d.getModel();

    return new LocalYRotationModel(editor3dModel, this.handleId, this.configuration);
};


LocalYRotationController.prototype.createView = function () {
    var editor3dView = this.editor3d.getView();

    return new LocalYRotationView(this.getModel(), editor3dView, this.handleId, this.configuration);
};



